import React from 'react';
import { 
  Box, 
  FormControlLabel, 
  Switch, 
  Typography,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

interface StatusSwitchesProps {
  isPostulada: boolean | null;
  isAdjudicada: boolean | null;
  fechaPostulacion?: string | null;
  fechaAdjudicacion?: string | null;
  onPostulacionChange?: (isPostulada: boolean) => void;
  onAdjudicacionChange?: (isAdjudicada: boolean) => void;
}

const StatusSwitches: React.FC<StatusSwitchesProps> = ({
  isPostulada = null,
  isAdjudicada = null,
  fechaPostulacion = null,
  fechaAdjudicacion = null,
  onPostulacionChange,
  onAdjudicacionChange
}) => {

  const handlePostulacionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    onPostulacionChange?.(newValue);
  };

  const handleAdjudicacionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    onAdjudicacionChange?.(newValue);
  };

  const formatDate = (dateString: string) => {
    try {
      return new Date(dateString).toLocaleDateString('es-CL', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } catch {
      return dateString;
    }
  };

  return (
    <Box>
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, flexWrap: 'wrap' }}>
              {isPostulada ? (
                <CheckCircleIcon color="success" />
              ) : (
                <CancelIcon color="error" />
              )}
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Ofertada
              </Typography>
              {fechaPostulacion && (
                <Typography variant="caption" sx={{ color: 'text.secondary'}}>
                  {formatDate(fechaPostulacion)}
                </Typography>
              )}
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={!!isPostulada}
                  onChange={handlePostulacionChange}
                  disabled={!!isAdjudicada}
                  color="primary"
                />
              }
              label=""
            />
          </Box>

          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1, flexWrap: 'wrap' }}>
              {isAdjudicada ? (
                <CheckCircleIcon color="success" />
              ) : (
                <CancelIcon color="error" />
              )}
              <Typography variant="body1" sx={{ fontWeight: 500 }}>
                Adjudicada
              </Typography>
              {fechaAdjudicacion && (
                <Typography variant="caption" sx={{ color: 'text.secondary'}}>
                  {formatDate(fechaAdjudicacion)}
                </Typography>
              )}
            </Box>
            <FormControlLabel
              control={
                <Switch
                  checked={!!isAdjudicada}
                  onChange={handleAdjudicacionChange}
                  disabled={!isPostulada}
                  color="success"
                />
              }
              label=""
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StatusSwitches; 